import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <>
      {/* Inline CSS inside <style> */}
      <style>{`
        .notfound-container {
          text-align: center;
          padding: 50px;
          font-family: Arial, sans-serif;
          animation: fadeIn 1s ease-in;
        }

        .notfound-code {
          font-size: 15rem;
          margin: 0;
          color: #ff4c4c;
          animation: bounce 1.5s infinite;
        }

        .notfound-message {
          font-size: 28px;
          margin: 10px 0;
          animation: slideDown 1s ease;
        }

        .notfound-text {
          color: #555;
          margin-bottom: 20px;
          animation: fadeIn 2s ease-in;
        }

        .notfound-button {
          text-decoration: none;
          background-color: #07509eff;
          color: #fff;
          padding: 10px 20px;
          border-radius: 8px;
          display: inline-block;
          transition: 0.3s;
        }

        .notfound-button:hover {
          background-color: #0a4788ff;
          transform: scale(1.1);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideDown {
          from { transform: translateY(-30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>

      <div className="notfound-container mt-5">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-message">Oops! Page Not Found</h2>
        <p className="notfound-text">
          The page you are looking for doesn’t exist or has been moved.
        </p>
        <Link to="/" className="notfound-button">
          Go Back Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;
